import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { SolicitudModificacionService } from '../../../services/formulacion/solicitud-modificacion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { FuenteService, FusService, GeneralService, OrganismoService, ReversionService, SolicitudPacService } from '../../../services/service.index';
import { ElementSchemaRegistry } from '@angular/compiler';

declare var jQuery: any;
declare var toastr;
@Component({
  selector: 'app-pac-solicitud',
  templateUrl: './pac-solicitud.component.html',
  styleUrls: []
})
export class PacSolicitudComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  esNuevaObs: boolean = false;
  montoMaximo: number = 0;
  montoMinimo: number = 0;
  Dti: any[];
  claseOC: any[];
  dataResourceObs: any[];
  dataResourceInf: any[];
  fechaPub: Date = new Date();
  fechaIC: Date = new Date();
  mes_fin: number = 0;
  i: string;
  f: string;
  dataResourceFF: any[];
  dataResourceOR: any[];
  montoTotal: number = 0;
  fusEdit: any[];
  nro_fus: string = '';
  verDatos: boolean = false;
  jusReversion = false;
  observacion = false;
  rol: number;
  monto_revertido: number = 0;
  monto_fus: number = 0;
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['application/pdf'];
  montoFus: number = 0;
  solicitudes: any[];
  fuses: any[];
  segSolicitudes: any[];
  techoId: string;
  idSolicitud: number;
  idAux: number;
  fusReversion: any;
  popupVisibleEstado: boolean = false;
  popupVisibleSeg: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleSolicitud: boolean = false;
  popupVisibleCambiarEstado: boolean = false;
  popupVisibleR: boolean = false;
  hasError: any;
  esReversion: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  modelSegu: any = { idSolicitud: 0, fus_id: 0, justificacion: '', estado_solicitud: '', estado_solicitud_id: 0, monto_solicitado: 0, tipo_reversion: '', tipo_reversion_id: 0, estado_id: 0, observacion: '', detalle: [] }
  model: any = { id: 0, fus_id: 0, objeto_contratacion: '', estado: '', estado_id: 0, total: 0, fuente_id: 0, techo_id: 0, organismo_id: 0, fecha_inicio: '', fecha_publicacion: '', tipo_inscripcion_id: 0, objeto_contratacion_id: 0, observacion_id: 0, informacion_id: 0 }
  estados: any[] = [{ id: 1, descripcion: 'OBSERVAR FUS' }, { id: 2, descripcion: 'REVERTIR FUS' }];
  gestion_id: number = 0;
  estadoCambiar: any[] = [{ id: 4, descripcion: 'APROBAR SOLICITUD' }, { id: 3, descripcion: 'OBSERVAR SOLICITUD' }];
  estadosFilter: any = [];
  estado: number;
  poaTecho: any;
  titulo: string = 'Solicitud de Inscripción al PAC';
  titulo_modal: string = '';
  constructor(private route: ActivatedRoute, private _sms: SolicitudModificacionService, private _spac: SolicitudPacService, private _fts: FuenteService, private _os: OrganismoService, private _fs: FusService, private _rs: ReversionService, private _gs: GeneralService) {

    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.gestion_id = u.gestion_id;
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();

    if (this.rol == 21) {
      this.estado = 10;
      this.getPoaTecho();
    }
    if (this.rol == 22) {
      this.estado = 11;
      this.titulo = 'Lista de Solicitudes de Inscripción al PAC';
      this.getPoaTecho();
    }
    if (this.rol == 11) {
      this.estado = 12;
      this.verDatos = true;
      this.titulo = 'Lista de Solicitudes de Inscripción al PAC';
    }

    this.resetErrors();
    this.getEstadosByUsuario();
    this.model.techo_id = parseInt(this.techoId);
  }

  ngOnInit() {
  }

  resetErrors() {
    this.hasError = { objeto_contratacion: false, estado: false, estado_id: false, total: false, fuente_id: false, tipo_reversion_id: false, organismo_id: false, fecha_inicio: false, fecha_publicacion: false, tipo_inscripcion_id: false, objeto_contratacion_id: false, observacion_id: false, informacion_id: false }
  }

  convertDate(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.poaTecho = result.data; }
        else { this.poaTecho = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListSolicitudesEstado(this.estado);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  refreshDataGrid2(e) {
    this.estado = e.value;
    this.getListSolicitudesEstado(this.estado);
  }

  getListSolicitudesEstado(estado_id: number) {
    if ((this.rol == 23) || (this.rol == 11) || (this.rol == 15)) {
      this.techoId = '0';
    }
    this._spac.listaSolicitudPacActivos(this.techoId, estado_id).subscribe(
      (response) => {

        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.solicitudes = result.data;
        }
        else { this.solicitudes = []; }
      },
      (error) => { console.log('Error', error); });
  }


  getFuente() {
    this._fts.getFuente().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceFF = result.data;
        } else {
          this.dataResourceFF = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getOrganismo() {
    this._os.getOrganismo().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceOR = result.data;
        } else {
          this.dataResourceOR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getObjetoContratacion() {
    this._fs.getObjetoContratacionTipo(0).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.claseOC = result.data;
        }
        else { this.claseOC = []; }
      },
      (error) => { console.log('Error', error); });
  }

  showModalAdd() {
    this.resetErrors();
    this.getlistaTipoInscripcion();
    this.getObjetoContratacion();
    this.getFuente();
    this.getOrganismo();
    this.titulo_modal = "REGISTRAR DATOS - SOLICITUD PAC";
    this.model.id = 0;
    this.model.objeto_contratacion = '';
    this.model.objeto_contratacion_id = '';
    this.model.objeto_contratacion_tipo_id = '';
    this.model.total = 0;
    this.model.fuente_id = 0;
    this.model.fus_id = 0;
    this.model.organismo_id = 0;
    this.verDatos = false;
    this.popupVisibleSolicitud = true;
    this.getMontoMaximo();
    this.getListaTipoInformacion();
  }

  getMontoMaximo() {
    if (this.model.tipo_inscripcion_id == 1) {
      this.montoMinimo = 20001;
      this.montoMaximo = 50000;
    }

    if (this.model.tipo_inscripcion_id == 2) {
      this.montoMinimo = 50001;
      this.montoMaximo = 200000;
    }
    if (this.model.tipo_inscripcion_id == 3) {
      this.montoMinimo = 200001;
      this.montoMaximo = 1000000;
    }
    if (this.model.tipo_inscripcion_id == 4) {
      this.montoMinimo = 1000001;
      this.montoMaximo = 70000000;
    }
    if (this.model.tipo_inscripcion_id == 5) {
      this.montoMinimo = 0;
      this.montoMaximo = 900000000;
    }
    if (this.model.tipo_inscripcion_id == 6) {
      this.montoMinimo = 0;
      this.montoMaximo = 900000000;
    }
    if (this.model.tipo_inscripcion_id == 7) {
      this.montoMinimo = 0;
      this.montoMaximo = 900000000;
    }
    if (this.model.tipo_inscripcion_id == 8) {
      this.montoMinimo = 20001;
      this.montoMaximo = 50000;
    }
    if (this.model.tipo_inscripcion_id == 9) {
      this.montoMinimo = 50001;
      this.montoMaximo = 900000000;
    }

  }

  getlistaTipoInscripcion() {
    this._spac.listaTipoInscripcion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.Dti = result.data;
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalDelete(id: number) {
    this.idSolicitud = id;
    this.popupVisibleDel = true;
  }

  getEnviarSolicitud(id: number, estado_id: number) {

    this.model.id = id;
    this.model.estado_id = estado_id;
    this.model.observacion = '';
    this.popupVisibleEstado = true;

  }

  getShowModalCambiarEstado(id: number, estado_id: number) {
    this.resetErrors();
    //this.modelSegu.estado_solicitud_id = 0;
    this.model.id = id;
    this.model.estado_id = estado_id;
    this.model.observacion = '';
    this.popupVisibleCambiarEstado = true;
  }

  deleteSolicitud() {
    this._spac.deleteSolicitud(this.idSolicitud).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleDel = false;
          this.getListSolicitudesEstado(this.estado);
          toastr.success('Operación realizada exitosamente.');
        } else if (result.status == 201) {
          this.popupVisibleDel = false;
          this.getListSolicitudesEstado(this.estado);
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          text: 'Actualizar',
          onClick: this.refreshDataGrid2.bind(this)
        }
      });
  }

  getDatosSolicitudDetalle(idSolicitud: number, idFus: number) {
    this._sms.getDatosSolicitudDetalle(idSolicitud, idFus).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusEdit = result.data;
          this.modelSegu.detalle = this.fusEdit;
        }
      },
      (error) => { console.log('Error', error); });
  }

  popupVisibleEditSolicitud(data: any, ver: string) {
    this.titulo_modal = "EDITAR DATOS - SOLICITUD PAC";
    this.getlistaTipoInscripcion();
    this.getObjetoContratacion();
    this.getFuente();
    this.getListaTipoInformacion();
    this.getOrganismo();
    this.resetErrors();
    if (ver == "1")
      this.verDatos = true;
    else
      this.verDatos = false;

      

    this.model.informacion_id = data.informacion_id;
    this.model.objeto_contratacion = data.objeto_contratacion;
    this.model.fuente_id = data.fuente_id;
    this.model.organismo_id = data.organismo_id;
    this.model.tipo_inscripcion_id = data.tipo_inscripcion_id;
    this.model.objeto_contratacion_id = data.objeto_contratacion_tipo_id;
    this.model.fus_id = 0;
    this.model.fecha_inicio = data.fecha_inicio;
    this.model.fecha_publicacion = data.fecha_publicacion;
    var fi = data.fecha_inicio.toString().split('-');
    this.fechaIC = new Date(fi[2], parseInt(fi[1]) - 1, fi[0]);
    var fp = data.fecha_publicacion.toString().split('-');
    this.fechaPub = new Date(fp[2], parseInt(fp[1]) - 1, fp[0]);
    this.model.total = data.total;
    this.model.id = data.id;
    this.popupVisibleSolicitud = true;
    this.getMontoMaximo();

  }




  saveSolicitud() {
    this.resetErrors();
    if (this.validSolicitud()) {
      this.model.fecha_inicio = this.convertDate(this.fechaIC);
      this.model.fecha_publicacion = this.convertDate(this.fechaPub);
      if (this.model.id == 0) {
        this._spac.postSolicitudPac(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getListSolicitudesEstado(this.estado);
              this.popupVisibleSolicitud = false;
              toastr.success('Datos guardados correctamente.');
            }
            else {
              toastr.warning(response.data);
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this._spac.putSolicitudPac(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisibleSolicitud = false;
              this.getListSolicitudesEstado(this.estado);
              toastr.success('Datos guardados correctamente.');
            } else if (result.status == 201) {
              toastr.warning(result.data);
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }

    } else {
      toastr.warning('Complete el formulario');
    }
  }

  aprobarEstado() {
    if (this.validCambioEstado()) {
      this._spac.putCambiosEstadoSolicitud(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleCambiarEstado = false;
            this.getListSolicitudesEstado(this.estado);
            toastr.success('Datos guardados correctamente.');
          }
          else if (result.status == 201) {
            toastr.warning(response.data);
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      toastr.warning('Debe Completar el formulario');
    }
  }

  enviarARevision() {
    this._spac.putCambiosEstadoSolicitud(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEstado = false;
          this.getListSolicitudesEstado(this.estado);
          toastr.success('Datos guardados correctamente.');
        }
        else if (result.status == 201) {
          toastr.warning(response.data);
        }
      },
      (error) => { console.log('Error', error); });

  }
  validCambioEstado() {
    let res = true;
    if (this.model.observacion == '') {
      this.hasError.observacion = true; res = false;
    }
    if (!UtilHelper.validator(this.model.estado_id, 0)) {
      this.hasError.estado_id = true; res = false;
    }
    return res;
  }

  validSolicitud() {

    let res = true, f1, total = 0;
    if (!UtilHelper.validator(this.model.objeto_contratacion, 'text')) {
      this.hasError.objeto_contratacion = true; res = false;
    }
    if (this.model.fuente_id == 0) {
      this.hasError.fuente_id = true; res = false;
    }
    if (this.model.informacion_id == 0) {
      this.hasError.informacion_id = true; res = false;
    }
    if (this.model.organismo_id == 0) {
      this.hasError.organismo_id = true; res = false;
    }
    if (this.model.tipo_inscripcion_id == 0) {
      this.hasError.tipo_inscripcion_id = true; res = false;
    }
    if (this.model.objeto_contratacion_id == 0) {
      this.hasError.objeto_contratacion_id = true; res = false;
    }

    if (!UtilHelper.validator(this.model.total, 0) || (this.model.total != 0) && (this.model.total < 1)) {
      this.hasError.valor_variable = true; res = false;
    }


    return res;
  }

  getTieneObservacion(e: any) {
    if (e.value == 2) {
      this.modelSegu.observacion = '';
    }
    else
      this.modelSegu.observacion = 'NINGUNA';
  }

  getTipoReversion(e: any) {
    if (e.value == 1) {
      this.modelSegu.tipo_reversion = 'REVERSION PARCIAL';
      this.modelSegu.detalle.forEach(item => {
        item.monto_solicitado = 0;
      });
    }
    if (e.value == 2) {
      this.modelSegu.tipo_reversion = 'REVERSION TOTAL';
      this.modelSegu.detalle.forEach(item => {
        item.monto_solicitado = item.monto_total_revertir;
      });
    }
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF.');
      }
    }
  }

  getListaTipoInformacion() {
    this._spac.listaTipoInformacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceInf = result.data;
        } else
          this.dataResourceInf = [];
      },
      (error) => { console.log('Error', error); });
  }

  getSolicitudById(data: any) {
    this.resetErrors();
    this.idSolicitud = parseInt(data.id);
    this.model.id = this.idSolicitud;

    this.getlistaTipoInscripcion();
    this.getObjetoContratacion();
    this.getFuente();
    this.getOrganismo();
    this.getListaTipoInformacion();

    this.model.objeto_contratacion = data.objeto_contratacion;
    this.model.fuente_id = data.fuente_id;
    this.model.organismo_id = data.organismo_id;
    this.model.tipo_inscripcion_id = data.tipo_inscripcion_id;
    this.model.objeto_contratacion_id = data.objeto_contratacion_tipo_id;
    this.model.fus_id = 0;
    this.model.informacion_id = data.informacion_id;
    this.model.fecha_inicio = data.fecha_inicio;
    this.model.fecha_publicacion = data.fecha_publicacion;
    var fi = data.fecha_inicio.toString().split('-');
    this.fechaIC = new Date(fi[2], parseInt(fi[1]) - 1, fi[0]);
    var fp = data.fecha_publicacion.toString().split('-');
    this.fechaPub = new Date(fp[2], parseInt(fp[1]) - 1, fp[0]);
    this.model.total = data.total;
    this.model.id = data.id;
    this.popupVisibleR = true;
    this.model.estado_id = '';

  }

  aprobarSolicitud() {
    this.resetErrors();
    this.jusReversion = false;
    this.observacion = false;
    if (this.validRev()) {
      this._spac.putCambiosEstadoSolicitud(this.model).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.model.estado_id = 0;
            this.popupVisibleR = false;
            this.getListSolicitudesEstado(this.estado);
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  validRev() {
    let res = true, f1 = false, f2 = false, f3 = false;
    if (!UtilHelper.validator(this.model.observacion, 'text')) {
      f1 = true;
    }

    // if (!UtilHelper.validator(this.model.observacion_id, 0)) {
    //   f2 = true;;
    // }

    if (this.model.estado_id == 0) {
      this.hasError.estado_id = true; f2 = true; res = false;
    }

    if (this.model.observacion == '') {
      this.hasError.observacion = true; f1 = true;
    }


    if (f1) {
      res = false;
      toastr.warning('Elija una observación');
    }
    // if (f2) {
    //   res = false;
    //   toastr.warning('Ingrese una observación');
    // }

    if (f3) {
      res = false;
      toastr.warning('Elija un estado');
    }

    return res;
  }

  showModalSeg(id: string, fus: string) {
    this.nro_fus = fus;
    this._sms.getSeguimientoByPacId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.segSolicitudes = result.data;
        }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }

  getObservacion() {
    if (this.model.estado_id != '') {
      if (this.model.estado_id == 4) {
        this.model.observacion = 'NINGUNA';
        this.esNuevaObs = false;
      }
      else {
        this.model.observacion_id = 0;
        this.model.estado_id = 3;
        this.getObservaciones();
        this.model.observacion = '';
      }
    }
  }

  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.model.observacion = '';
      this.esNuevaObs = true;
    }

    else {
      this.esNuevaObs = false;
      this.model.observacion = esNueva;
    }
  }

  getObservaciones() {
    this._gs.getObservaciones('PAC').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }


}
